PageApp.Views.ContentView = Backbone.Marionette.ItemView.extend({
  template: hbs.templates.contentView,
  serializeData: function () {
    return {
      containerClass: myApp.ent.config.get('containerClass'),
      content: this.model.get('content')
    }
  }
})
